"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _oipRecord = _interopRequireDefault(require("../oip-record"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Publisher = /*#__PURE__*/function (_oipRecord$default) {
  _inherits(Publisher, _oipRecord$default);

  var _super = _createSuper(Publisher);

  function Publisher() {
    var _this;

    _classCallCheck(this, Publisher);

    _this = _super.call(this);
    _this.txid = undefined;
    _this._publisher = {
      alias: undefined,
      floAddress: undefined,
      timestamp: undefined,
      authorized: [],
      info: {
        emailmd5: undefined,
        avatarNetwork: undefined,
        avatar: undefined,
        headerImageNetwork: undefined,
        headerImage: undefined
      },
      verification: {
        imdb: undefined,
        twitter: undefined,
        facebook: undefined
      }
    };
    return _this;
  }

  _createClass(Publisher, [{
    key: "setTXID",
    value: function setTXID(txid) {
      this.txid = txid;
    }
  }, {
    key: "getTXID",
    value: function getTXID() {
      return this.txid;
    }
  }, {
    key: "setAlias",
    value: function setAlias(alias) {
      if (typeof alias !== 'string') {
        throw new Error('Alias must be a string!');
      }

      this._publisher.alias = alias;
    }
  }, {
    key: "getAlias",
    value: function getAlias() {
      return this._publisher.alias;
    }
  }, {
    key: "setMainAddress",
    value: function setMainAddress(address) {
      this._publisher.floAddress = address;
    }
  }, {
    key: "getMainAddress",
    value: function getMainAddress() {
      return this._publisher.floAddress;
    }
  }, {
    key: "setTimestamp",
    value: function setTimestamp(timestamp) {
      if (typeof timestamp !== 'number') {
        throw new Error('Timestamp must be a Number!');
      }

      if (String(timestamp).length === 13) {
        var secondsTimeString = parseInt(timestamp / 1000);
        this._publisher.timestamp = secondsTimeString;
      } else if (String(timestamp).length === 10) {
        this._publisher.timestamp = timestamp;
      }
    }
  }, {
    key: "getTimestamp",
    value: function getTimestamp() {
      return this._publisher.timestamp;
    }
  }, {
    key: "addAuthorizedAddress",
    value: function addAuthorizedAddress(address) {
      if (typeof address !== 'string') {
        throw new Error('Authorized Address must be a string!');
      }
    }
  }, {
    key: "getAuthorizedAddresses",
    value: function getAuthorizedAddresses() {
      return this._publisher.authorized;
    }
  }, {
    key: "setEmailMD5",
    value: function setEmailMD5(emailmd5) {
      if (typeof emailmd5 !== 'string') {
        throw new Error('Email MD5 must be a string!');
      }

      this._publisher.info.emailmd5 = emailmd5;
    }
  }, {
    key: "getEmailMD5",
    value: function getEmailMD5() {
      return this._publisher.info.emailmd5;
    }
  }, {
    key: "setAvatarNetwork",
    value: function setAvatarNetwork(network) {
      if (typeof network !== 'string') {
        throw new Error('Network must be a string!');
      }

      this._publisher.info.avatarNetwork = network;
    }
  }, {
    key: "getAvatarNetwork",
    value: function getAvatarNetwork() {
      return this._publisher.info.avatarNetwork;
    }
  }, {
    key: "setAvatar",
    value: function setAvatar(avatar) {
      if (typeof avatar !== 'string') {
        throw new Error('Avatar Location must be a string!');
      }

      this._publisher.info.avatar = avatar;
    }
  }, {
    key: "getAvatar",
    value: function getAvatar() {
      return this._publisher.info.avatar;
    }
  }, {
    key: "setHeaderNetwork",
    value: function setHeaderNetwork(network) {
      if (typeof network !== 'string') {
        throw new Error('Network must be a string!');
      }

      this._publisher.info.headerImageNetwork = network;
    }
  }, {
    key: "getHeaderNetwork",
    value: function getHeaderNetwork() {
      return this._publisher.info.headerImageNetwork;
    }
  }, {
    key: "setHeader",
    value: function setHeader(header) {
      if (typeof header !== 'string') {
        throw new Error('Header Location must be a string!');
      }

      this._publisher.info.headerImage = header;
    }
  }, {
    key: "getHeader",
    value: function getHeader() {
      return this._publisher.info.headerImage;
    }
  }, {
    key: "setVerification",
    value: function setVerification(type, verificationUrl) {
      if (typeof type !== 'string') {
        throw new Error('Verification Type must be a string!');
      }

      if (typeof verificationUrl !== 'string') {
        throw new Error('Verification URL must be a string!');
      } // Test if verification type is allowed


      var supportedVerificationTypes = Object.keys(this._publisher.verification);

      if (supportedVerificationTypes.indexOf(type) === -1) {
        throw new Error("Verification for ".concat(type, " is not yet supported!"));
      }

      this._publisher.verification[type] = verificationUrl;
    }
  }, {
    key: "getVerification",
    value: function getVerification(type) {
      if (typeof type !== 'string') {
        throw new Error('Verification Type must be a string!');
      } // Test if verification type is allowed


      var supportedVerificationTypes = Object.keys(this._publisher.verification);

      if (supportedVerificationTypes.indexOf(type) === -1) {
        throw new Error("Verification for ".concat(type, " is not yet supported!"));
      }

      return this._publisher.verification[type];
    }
  }]);

  return Publisher;
}(_oipRecord.default);

exports.default = Publisher;